export function handleHTTPError(error, callback) {
  const { response } = error;
  if (response) {
    return response.data
      ? callback(JSON.stringify(response.data))
      : callback(JSON.stringify(response));
  }
  return callback(JSON.stringify(error));
}
